import React from 'react'

import { EmailCampaignMetricType } from 'api/email/types'
import ChipButton from 'components/core/ChipButton'

import './style.css'

export const EmailCampaignMetricDisplayName = {
  [EmailCampaignMetricType.ENROLLED]: 'Enrolled',
  [EmailCampaignMetricType.UNENROLLED]: 'Unenrolled',
  [EmailCampaignMetricType.COMPLETED]: 'Completed',
  [EmailCampaignMetricType.SENT]: 'Sent',
  [EmailCampaignMetricType.DELIVERED]: 'Delivered',
  [EmailCampaignMetricType.OPENED]: 'Opened',
  [EmailCampaignMetricType.CLICKED]: 'Clicked',
  [EmailCampaignMetricType.REPLIED]: 'Replied',
  [EmailCampaignMetricType.BOUNCED]: 'Bounced',
  [EmailCampaignMetricType.UNSUBSCRIBED]: 'Unsubscribed',
}

const MetricOptions = ({ value, onChange }) => (
  <div className="email-campaign-performance-chart--metric-option-container">
    {Object.values(EmailCampaignMetricType).map((metric) => (
      <ChipButton
        className="email-campaign-performance-chart--metric-option-button"
        isSelected={metric === value}
        key={metric}
        onClick={() => onChange(metric)}
      >
        {EmailCampaignMetricDisplayName[metric]}
      </ChipButton>
    ))}
  </div>
)

export default MetricOptions
